<template>
    <a-layout class="provisioning-layout">
        <a-row>
            <ProvisioningHeader />
            <ProvisioningTitle>
                <template #title>
                    <h3 class="title_font_Weight">服務條款</h3>
                </template>
                <template #subTitle>
                    <p class="sub_title_width">
                        此裝置 (裝置碼)尚未完成開通，請輸入以下資訊完成開通程序：
                    </p>
                </template>
            </ProvisioningTitle>    
            <ProvisioningTerms />
            <ProvisioningAgreeButton />
        </a-row>
    </a-layout>
</template>

<script>
    import ProvisioningHeader from "../../components/deviceProvision/ProvisioningHeader.vue";
    import ProvisioningTitle from "../../components/deviceProvision/ProvisioningTitle.vue";
    import ProvisioningTerms from "../../components/deviceProvision/ProvisioningTerms.vue";
    import ProvisioningAgreeButton from "../../components/deviceProvision/ProvisioningAgreeButton.vue";

    export default {
        name: 'ProvisioningAgreeContainer',
        components: {
            ProvisioningHeader,
            ProvisioningTitle, 
            ProvisioningTerms, 
            ProvisioningAgreeButton,
        },
    }
</script>
